import { GenerationsPage } from "../GenerationsPage";
import { PanelSection } from "./PanelSection";
import { ScreenFrame } from "./ScreenFrame";
import { SettingsSection } from "./SettingsSection";

export function TextsAiScreen(): JSX.Element {
  return (
    <ScreenFrame screen="texts-ai">
      <SettingsSection screen="texts-ai" />
      <PanelSection title="Generations" panelIds={["tuning_table_operation_by_model", "generation_log"]}>
        <GenerationsPage />
      </PanelSection>
    </ScreenFrame>
  );
}
